import { PostgrestResponse } from '@supabase/supabase-js';
import { IVwExtratoConsumoAluno } from '../../../types/views/IVwExtratoConsumoAluno';
import { BaseMultiTenantService } from '../base/BaseMultiTenantService';

/**
 * View para extrato de consumo por aluno
 * Corresponde à view 'vw_extrato_consumo_aluno' no banco de dados
 */
export class ViewExtratoConsumoAluno extends BaseMultiTenantService<IVwExtratoConsumoAluno[]> {
    constructor() {
        super('vw_extrato_consumo_aluno', [], 'fk_id_organizacao');
    }

    /**
     * Extrato completo de consumo por aluno
     */
    async getExtrato(organizationId: number): Promise<PostgrestResponse<IVwExtratoConsumoAluno[]>> {
        return await this.client
            .from(this.tableName)
            .select('*')
            .eq(this.organizationIdField, organizationId)
            .order('data_venda', { ascending: false });
    }

    /**
     * Extrato de consumo de um aluno específico
     */
    async getExtratoPorAluno(organizationId: number, alunoId: number, limite: number = 10): Promise<PostgrestResponse<IVwExtratoConsumoAluno[]>> {
        return await this.client
            .from(this.tableName)
            .select('*')
            .eq(this.organizationIdField, organizationId)
            .eq('fk_id_aluno', alunoId)
            .order('data_venda', { ascending: false })
            .limit(limite);
    }

    /**
     * Extrato por período
     */
    async getExtratoPorPeriodo(organizationId: number, alunoId: number, dataInicio: string, dataFim: string): Promise<PostgrestResponse<IVwExtratoConsumoAluno[]>> {
        return await this.client
            .from(this.tableName)
            .select('*')
            .eq(this.organizationIdField, organizationId)
            .eq('fk_id_aluno', alunoId)
            .gte('data_venda', dataInicio)
            .lte('data_venda', dataFim)
            .order('data_venda', { ascending: false });
    }

    /**
     * Estatísticas de consumo por aluno (resumo)
     */
    async getResumoPorAluno(organizationId: number, alunoId: number): Promise<{
        totalItens: number;
        valorTotal: number;
        valorMedio: number;
        ultimaCompra: string | null;
    }> {
        const { data } = await this.client
            .from(this.tableName)
            .select(`
                item_id.count(),
                valor_item.sum(),
                valor_item.avg(),
                data_venda.max()
            `)
            .eq(this.organizationIdField, organizationId)
            .eq('fk_id_aluno', alunoId);

        return {
            totalItens: data?.[0]?.count || 0,
            valorTotal: data?.[0]?.sum || 0,
            valorMedio: data?.[0]?.avg || 0,
            ultimaCompra: data?.[0]?.max ? String(data[0].max) : null
        };
    }
}

export const viewExtratoConsumoAluno = new ViewExtratoConsumoAluno();
